export const SET_FETCHING = 'SET_FETCHING';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

/* DATE PICKER */
export const DATE_FORMAT = 'YYYY-MM-DD';
export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD';
export const TYPE = {
    END_DATE: 'END_DATE',
    START_DATE: 'START_DATE'
};

/* MAP */
// export const GOOGLE_API_KEY = 'AIzaSyD0lxFndY14uX-PpsQhYCqHMRsUrWq5IEg';
// апи кей оказывается у нас тут и лежит... продолжим эту славную традицию
export const GOOGLE_API_KEY = 'AIzaSyDFIOV6fR_9fOdDKBrcJJpP7r_mmiIU20E';



// WEBPACK FOOTER //
// ./src/constants/App.js